import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CircleAlert, LucideAngularModule, RefreshCw } from 'lucide-angular';

@Component({
  selector: 'app-error-state',
  imports: [CommonModule, LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div aria-live="assertive" class="rounded-lg border border-red-200 bg-red-50 p-6 text-center" role="alert">
      <lucide-icon aria-hidden="true" class="w-12 h-12 text-red-400 mx-auto mb-4" [name]="alertIcon" />
      <h3 class="text-lg font-medium text-red-800 mb-2">{{ title() }}</h3>
      <p class="text-red-600 mb-4">{{ message() }}</p>
      @if (showRetry()) {
        <button
          class="inline-flex items-center gap-2 px-4 py-2 bg-red-100 hover:bg-red-200 text-red-700 rounded-lg transition-colors cursor-pointer"
          type="button"
          (click)="handleRetry()">
          <lucide-icon class="w-4 h-4" [name]="refreshIcon" />
          Try again
        </button>
      }
    </div>
  `,
})
export class ErrorStateComponent {
  readonly title = input<string>('Something went wrong');
  readonly message = input<string>('Unable to load data. Please try again.');
  readonly showRetry = input<boolean>(true);
  readonly retry = output<void>();

  readonly alertIcon = CircleAlert;
  readonly refreshIcon = RefreshCw;

  handleRetry(): void {
    console.log('handleRetry');
    this.retry.emit();
  }
}
